module.exports = {"origin":"https://authapi.51tuoguanyun.com","page":"https://portal.51tuoguanyun.com"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/pro.json
 ** module id = 757
 ** module chunks = 1
 **/